import { render, staticRenderFns } from "./rightDrawer.vue?vue&type=template&id=b7239c9a&scoped=true"
import script from "./rightDrawer.vue?vue&type=script&lang=js"
export * from "./rightDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7239c9a",
  null
  
)

export default component.exports